import { render, staticRenderFns } from "./ListAttributes.vue?vue&type=template&id=2e1f6999"
import script from "./ListAttributes.vue?vue&type=script&lang=js"
export * from "./ListAttributes.vue?vue&type=script&lang=js"
import style0 from "./ListAttributes.vue?vue&type=style&index=0&id=2e1f6999&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports